import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createSlots as _createSlots, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ea5c9a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "splash" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = { class: "tab-strip-menu" }
const _hoisted_4 = { class: "header-search-buttons" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-close .k-i-x" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  id: "searchOrderSidePanel",
  class: "sidepanel"
}
const _hoisted_9 = { class: "side-bar-close-wrapper" }
const _hoisted_10 = { class: "input-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Order No:", -1))
const _hoisted_12 = { class: "input-container" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Customer(name / email / id or postcode):", -1))
const _hoisted_14 = { class: "input-container" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Owner:", -1))
const _hoisted_16 = { class: "input-container" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Tracking Number:", -1))
const _hoisted_18 = { class: "d-flex" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Search ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-zoom k-i-search" }, null, -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-close .k-i-x" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { ref: "grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_button = _resolveComponent("k-button")!
  const _component_k_button_group = _resolveComponent("k-button-group")!
  const _component_KTabStrip = _resolveComponent("KTabStrip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_KTabStrip, {
          selected: _ctx.selectedTab,
          "tab-position": 'top',
          tabs: _ctx.GridFilterCategories,
          onSelect: _ctx.onSelectTab
        }, _createSlots({ _: 2 }, [
          _renderList(_ctx.GridFilterCategories, (category) => {
            return {
              name: category.id,
              fn: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_k_button_group, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGridFiltersByCategoryId(
                    category.id,
                  ), (gridFilter, gfi) => {
                        return (_openBlock(), _createBlock(_component_k_button, {
                          key: gfi,
                          toggable: true,
                          "fill-mode": 'flat',
                          selected: _ctx.isSelected(gridFilter.Id ?? 0),
                          class: _normalizeClass([_ctx.getButtonClass(gridFilter)]),
                          onClick: ($event: any) => (_ctx.onSelectEvent(gridFilter.Id ?? 0, $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(gridFilter.Name), 1)
                          ]),
                          _: 2
                        }, 1032, ["selected", "class", "onClick"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ])
              ])
            }
          })
        ]), 1032, ["selected", "tabs", "onSelect"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-primary m-2 p-1",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openSearchMenu()))
        }, " Search "),
        (_ctx.isClearSearch())
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "btn btn-danger m-2 p-1",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearSearchClick()))
              }, _hoisted_7)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", {
          class: "k-icon k-i-close .k-i-x",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeSearchMenu()))
        })
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.orderNumberValue) = $event)),
          class: "form-control",
          type: "number",
          min: "0"
        }, null, 512), [
          [_vModelText, _ctx.orderNumberValue]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customerValue) = $event)),
          class: "form-control",
          type: "text"
        }, null, 512), [
          [_vModelText, _ctx.customerValue]
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ownerValue) = $event)),
          class: "form-control",
          type: "text"
        }, null, 512), [
          [_vModelText, _ctx.ownerValue]
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.trackingNumberValue) = $event)),
          class: "form-control",
          type: "text"
        }, null, 512), [
          [_vModelText, _ctx.trackingNumberValue]
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn btn-primary m-2 p-1",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.refreshGrid()))
          }, _hoisted_21)
        ]),
        (_ctx.isClearSearch())
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("button", {
                class: "btn btn-danger m-2 p-1",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clearSearchClick()))
              }, _hoisted_24)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_25, null, 512)
  ]))
}